import FootprintsMap, { MapAddress } from "./FootprintsMap";

export { MapAddress };

export default FootprintsMap;
